import {LEAGUES} from '../../constants/leagues';
import {parseRankSkinId} from './getFactionRankSkinTitle';

/**
 * Рамки рейтинговых образов: их накладывают ПОВЕРХ иконки фракции игрока и
 * поверх самого образа в карусели, чтобы редкий образ был виден сразу, без
 * подписи. Рамка есть только у трех высших лиг — обычные образы и базовый вид
 * фракции идут без нее (см. RANK_SKIN_DISPLAY).
 */
export const RANK_SKIN_FRAME_PATHS = {
  [LEAGUES.GOLD]: '/img/other/frame_gold.png',
  [LEAGUES.DIAMOND]: '/img/other/frame_diamond.png',
  [LEAGUES.RUBY]: '/img/other/frame_ruby.png',
};

/**
 * Рамка по лиге образа.
 *
 * @param {string} [rank] - лига образа (`gold` | `diamond` | `ruby`)
 * @returns {string|null} путь к картинке рамки или null
 */
export const getRankSkinFrameByRank = (rank) => RANK_SKIN_FRAME_PATHS[rank] || null;

/**
 * Рамка по идентификатору образа (`humans_gold`, `orcs_diamond`,
 * `dark_elves_ruby`). У любого
 * другого образа, у базового вида фракции и без образа вовсе рамки нет.
 *
 * @param {string} [skinId] - идентификатор образа
 * @returns {string|null} путь к картинке рамки или null
 */
export const getRankSkinFramePath = (skinId) => {
  if (!skinId) {
    return null;
  }

  return getRankSkinFrameByRank(parseRankSkinId(skinId).rank);
};
